const PRODUCTION_HOST = 'www.xing.com';
const PREFIX_BREWERY_REST = '/static';
const PREFIX_PREVIEW_AWS = 'https://preview-static.xingcdn.com';
const PREFIX_PRODUCTION_AWS = 'https://static.xingcdn.com';
export const getDataHost = (hostname, isBrewery) => {
    const isLocalhost = hostname === 'localhost';
    const isCI = hostname.match(/^ci-docker\d+\.env\.xing\.com$/);
    if (isBrewery && (isLocalhost || isCI)) {
        return PREFIX_BREWERY_REST;
    }
    if (hostname === PRODUCTION_HOST)
        return PREFIX_PRODUCTION_AWS;
    return PREFIX_PREVIEW_AWS;
};
//# sourceMappingURL=get-data-host.js.map